"use client";
import { ICPServiceType1 } from "@/types/global";

interface Props {
    data: ICPServiceType1;
    i?: number;
}

const ServiceAreaCard = ({ data }: Props) => {
    return (
        <div className="col-md-6 d-flex">
            <div className="desilo-service-box style-2">
                <div className="h-100 d-flex flex-column">
                    <div className="h-100 d-flex flex-column justify-content-between">
                        <div>
                            <h3>{data.title}</h3>
                            <p>{data.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceAreaCard;
